// 腾讯云 COS 基础 URL（构建期只引用，不下载）
const COS_URL = 'https://zixiancao-1306805299.cos.ap-guangzhou.myqcloud.com';

// Logo images
export const logo = `${COS_URL}/images/logo.png`;
export const logoWhite = `${COS_URL}/images/logo-white.png`;

// 产品图片资源
const images = {
  shihu1: `${COS_URL}/images/shihu-1.jpg`,
  shihu2: `${COS_URL}/images/shihu-2.jpg`,
  shihu3: `${COS_URL}/images/shihu-3.jpg`,
  sanqi1: `${COS_URL}/images/sanqi-1.jpg`,
  sanqi2: `${COS_URL}/images/sanqi-2.jpg`,
  sanqi3: `${COS_URL}/images/sanqi-3.jpg`,
  lingzhi1: `${COS_URL}/images/lingzhi-1.jpg`,
  lingzhi2: `${COS_URL}/images/lingzhi-2.jpg`,
  lingzhi3: `${COS_URL}/images/lingzhi-3.jpg`,
  oil1: `${COS_URL}/images/oil-1.jpg`,
  oil2: `${COS_URL}/images/oil-2.jpg`,
  oil3: `${COS_URL}/images/oil-3.jpg`
};

// 只有产品名称与图片来自已有素材；价格、认证、疗效、销量、年限、投资额等
// 未经核实的断言已从活跃页面移除，待核项见 docs/fact-check-backlog.md。
// 规格、配料、生产许可证号等资料未提供，页面统一提示以实际包装为准。
const PACKAGING_NOTE = '规格、配料与生产信息请以实际产品包装标示为准，也可以先咨询企业顾问。';

/**
 * @typedef {Object} ProductCopy
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {string} image
 * @property {string[]} features
 * @property {string} usage
 * @property {string} [packagingNote]
 */

export const products = {
  shihu: [
    {
      id: 'shihu1',
      title: '紫皮石斛原浆礼盒装',
      description: '云南紫皮石斛即食原浆的礼盒装，适合自用与送礼。',
      image: images.shihu1,
      features: ['云南紫皮石斛', '即食原浆', '礼盒装'],
      usage: '包装未在本站公布具体食用方法，请以实际包装说明为准。',
      packagingNote: PACKAGING_NOTE
    },
    {
      id: 'shihu2',
      title: '紫皮石斛原浆量贩装',
      description: '云南紫皮石斛即食原浆的量贩装，包装规格更大，适合长期饮用。',
      image: images.shihu2,
      features: ['云南紫皮石斛', '即食原浆', '量贩装'],
      usage: '包装未在本站公布具体食用方法，请以实际包装说明为准。',
      packagingNote: PACKAGING_NOTE
    },
    {
      id: 'shihu3',
      title: '铁皮石斛原浆',
      description: '以铁皮石斛为原料的即食原浆产品。',
      image: images.shihu3,
      features: ['铁皮石斛', '即食原浆'],
      usage: '包装未在本站公布具体食用方法，请以实际包装说明为准。',
      packagingNote: PACKAGING_NOTE
    }
  ],
  sanqi: [
    {
      id: 'sanqi1',
      title: '有机生三七粉',
      description: '以云南文山三七为原料研磨的生三七粉。',
      image: images.sanqi1,
      features: ['云南文山三七原料', '三七粉'],
      usage: '包装未在本站公布具体食用方法，请以实际包装说明为准。',
      packagingNote: PACKAGING_NOTE
    },
    {
      id: 'sanqi2',
      title: '有机熟三七粉',
      description: '以云南文山三七为原料、经熟制处理的三七粉。',
      image: images.sanqi2,
      features: ['云南文山三七原料', '熟制三七粉'],
      usage: '包装未在本站公布具体食用方法，请以实际包装说明为准。',
      packagingNote: PACKAGING_NOTE
    },
    {
      id: 'sanqi3',
      title: '有机生三七粉量贩装',
      description: '生三七粉的大包装规格，原料同样来自云南文山。',
      image: images.sanqi3,
      features: ['云南文山三七原料', '量贩装'],
      usage: '包装未在本站公布具体食用方法，请以实际包装说明为准。',
      packagingNote: PACKAGING_NOTE
    }
  ],
  lingzhi: [
    {
      id: 'lingzhi1',
      title: '灵芝孢子粉',
      description: '滋仙草灵芝系列的灵芝孢子粉产品。',
      image: images.lingzhi1,
      features: ['灵芝孢子粉'],
      usage: '包装未在本站公布具体食用方法，请以实际包装说明为准。',
      packagingNote: PACKAGING_NOTE
    },
    {
      id: 'lingzhi2',
      title: '灵芝菌汤包',
      description: '含云南菌菇与灵芝的汤包产品，可用于日常煲汤。',
      image: images.lingzhi2,
      features: ['云南菌菇与灵芝', '汤包'],
      usage: '烹煮方式请以实际包装说明为准。',
      packagingNote: PACKAGING_NOTE
    },
    {
      id: 'lingzhi3',
      title: '灵芝孢子油',
      description: '滋仙草灵芝系列的灵芝孢子油产品，原料来自云南高黎贡山。',
      image: images.lingzhi3,
      features: ['云南高黎贡山原料', '孢子油'],
      usage: '包装未在本站公布具体食用方法，请以实际包装说明为准。',
      packagingNote: PACKAGING_NOTE
    }
  ],
  jingyou: [
    {
      id: 'oil1',
      title: '三七靓颜精油',
      description: '提取自三七的护理精油，外用。',
      image: images.oil1,
      features: ['三七提取', '外用护理精油'],
      usage: '外用产品，使用方式请以实际包装说明为准。',
      packagingNote: PACKAGING_NOTE
    },
    {
      id: 'oil2',
      title: '当归舒缓精油',
      description: '以当归为原料的护理精油，外用。',
      image: images.oil2,
      features: ['当归原料', '外用护理精油'],
      usage: '外用产品，使用方式请以实际包装说明为准。',
      packagingNote: PACKAGING_NOTE
    }
  ]
};

export const productCategories = [
  { id: 'shihu', name: '石斛系列' },
  { id: 'sanqi', name: '三七系列' },
  { id: 'lingzhi', name: '灵芝系列' },
  { id: 'jingyou', name: '精油系列' }
];

// 三款石斛产品有独立详情页，其余分类保留列表入口。
export const showcasedProductIds = ['shihu1', 'shihu2', 'shihu3'];

/**
 * @param {string} id
 * @returns {ProductCopy | null}
 */
export function findProductById(id) {
  for (const list of Object.values(products)) {
    const found = list.find((product) => product.id === id);
    if (found) return found;
  }
  return null;
}

export default {
  logo,
  logoWhite,
  products,
  productCategories,
  showcasedProductIds,
  findProductById,
  images
};
